import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import type { CoachingTimelineItem } from '../../../../queries/CallAdherence/useCallAdherenceTimelineQuery';
import { SparklesIcon } from '../../../../web/components/svgs/icons/SparklesIcon';
import { StreamdownLite } from '../../../../web/components-v2/ai/StreamdownLite';
import { brandPrimary } from '../../../styles/colors';
import { styleSheet } from '../styles';

const aiRoleLabel = (role: Api.AIChatRole): string => (role === Api.AIChatRole.Assistant ? 'AI Coach' : 'You (to AI)');

export const AdherenceTimelineRow: React.FC<{ row: CoachingTimelineItem }> = ({ row }) => {
	if (row._type === 'SpeakerLineTimelineItem') {
		return (
			<p className={css(styleSheet.transcriptionContentLine)}>
				<span className={css(styleSheet.transcriptionContentSpeaker)}>{row.speaker}:</span> {row.line}
			</p>
		);
	}
	return (
		<div className={css(styleSheet.adherenceAiRow)}>
			<div className={css(styleSheet.adherenceAiRowHeader)}>
				<span className={css(styleSheet.adherenceAiRowIcon)}>
					<SparklesIcon style={{ color: brandPrimary }} />
				</span>
				<span className={css(styleSheet.adherenceAiRowLabel)}>{aiRoleLabel(row.role)}</span>
			</div>
			<StreamdownLite styles={[styleSheet.adherenceAiRowBody]} parseIncompleteMarkdown={false}>
				{row.text}
			</StreamdownLite>
		</div>
	);
};
